import Blazy from './../vendor/blazy'
import meta from './../bankrate-tracking/meta'

const prevSelector = '[data-prev-slide]'
const nextSelector = '[data-next-slide]'
const scrollToTop = 'data-scroll-top'
const showAllSelector = '[data-show-all]'
const jumpOffSelector = '.trending__list a'
const upNextContainer = document.querySelector('.up-next')
const bLazy = new Blazy({ selector: '[data-lazy-load]' })
const controls = document.querySelector('[data-slide-controls]')

let slides = []
let slideCount = 0
let currentSlide = 1
let jumpOffURL = false
let secondaryPageView = false
let abTest = false

let init = function init() {
  slides = [].slice.call(document.querySelectorAll('[data-slide]'))
  slideCount = slides.length
  if (slideCount > 0) {
    window.onpopstate = changeToSlide
    setImagesAsNextButtons()

    let test = controls.getAttribute('data-ab-test')
    abTest = test && test === 'true' ? true : false

    if (!abTest) {
      moveControlsUnderImg()
    }

    let hashNumber = extractSlideNumber(window.location.hash)
    currentSlide = hashNumber > slideCount || hashNumber < 0 ? 1 : hashNumber
    changeToSlide(currentSlide)
    bLazy.revalidate()

    setTimeout(
      function(bLazy) {
        bLazy.revalidate()
      },
      200,
      bLazy
    )

    let jumpOffElm = document.querySelector(jumpOffSelector)
    jumpOffURL = jumpOffElm ? jumpOffElm.getAttribute('href') : false

    Array.prototype.forEach.call(
      document.querySelectorAll(nextSelector),
      function(item) {
        item.addEventListener('mouseover', function() {
          if (upNextContainer) {
            upNextContainer.classList.add('--hide')
          }
        })
        item.addEventListener('mouseout', function() {
          if (upNextContainer && currentSlide === slideCount) {
            upNextContainer.classList.remove('--hide')
          }
        })
      }
    )
  }
}

let setImagesAsNextButtons = function setImagesAsNextButtons() {
  let images = [].slice.call(document.querySelectorAll('[data-slide] img'))

  images.forEach(function(item) {
    item.setAttribute(nextSelector.replace(/\[|\]/g, ''), 'true')
  })
}

let moveControlsUnderImg = function moveControlsUnderImg() {
  let featuredElm = []
  ;[].slice
    .call(document.querySelectorAll('[data-slide]'))
    .forEach(function(item) {
      let onePerSlide = false
      let image = item.querySelector('img')

      if (image) {
        featuredElm.push(image)
        onePerSlide = true
      }

      let iframe = item.querySelector('iframe')

      if (iframe && onePerSlide === false) {
        featuredElm.push(iframe)
        onePerSlide = true
      }

      let video = item.querySelector('[data-video-player]')

      if (video && onePerSlide === false) {
        featuredElm.push(video)
      }
    })

  if (featuredElm.length && controls) {
    featuredElm.forEach(function(item) {
      let clone = controls.cloneNode(true)
      item.parentNode.insertBefore(clone, item.nextSibling)
    })
  }
}

let stopVideos = function stopVideos(currentSlide) {
  let videos = [].slice.call(document.querySelectorAll('[data-slide] video'))
  let iframeVideos = [].slice.call(
    document.querySelectorAll('[data-slide] iframe')
  )

  videos.forEach(function(item) {
    item.pause()
  })

  iframeVideos.forEach(function(item) {
    if (!item.getAttribute('data-src')) {
      item.setAttribute('data-src', item.src)
    }

    item.src = ''

    let currentSlideIframeVideo = document.querySelector(
      '[data-slide="' + currentSlide + '"] iframe'
    )

    if (currentSlideIframeVideo) {
      currentSlideIframeVideo.src = currentSlideIframeVideo.getAttribute(
        'data-src'
      )
    }
  })
}

let extractSlideNumber = function extractSlideNumber(hash) {
  let paramsObj = getQueryParameters(hash.replace('#', '?'))
  return paramsObj &&
    paramsObj.slide &&
    Number.isInteger(Number(paramsObj.slide))
    ? Number(paramsObj.slide)
    : 1
}

let getQueryParameters = function getQueryParameters(str) {
  return (str || document.location.search)
    .replace(/(^\?)/, '')
    .split('&')
    .map(
      function(n) {
        return (n = n.split('=')), (this[n[0]] = n[1]), this
      }.bind({})
    )[0]
}

let removeActiveClass = function removeActiveClass() {
  slides.forEach(function(elm) {
    elm.classList.remove('active')
  })
}

let addActiveClass = function addActiveClass(num) {
  let slide = document.querySelector('[data-slide="' + num + '"]')

  if (slide) {
    slide.classList.add('active')
  }
}

let showAll = function showAll() {
  slides.forEach(function(elm) {
    elm.classList.add('active')
  })
  currentSlide = 0
  updateSlideHash(0)
  bLazy.revalidate()
  pageView()
}

let updateSlideHash = function updateSlideHash(num) {
  let paramsObj =
    window.location.hash.length > 0
      ? getQueryParameters(window.location.hash.replace('#', ''))
      : {}

  paramsObj.slide = num

  let str = ''
  for (let param in paramsObj) {
    if (param && typeof paramsObj[param] !== 'undefined') {
      str += '&' + param + '=' + paramsObj[param]
    }
  }

  str = str.replace('&', '')

  window.history.replaceState(
    { slide: currentSlide },
    document.title,
    '#' + str
  )
}

let changeToSlide = function changeToSlide(num) {
  if (window.location.hash.length > 0 && !/slide/.test(window.location.hash)) {
    return
  }

  currentSlide = Number.isInteger(num)
    ? num
    : extractSlideNumber(window.location.hash)
  removeActiveClass()

  if (currentSlide === 0) {
    showAll()
  } else {
    addActiveClass(currentSlide)
  }

  dispatchSlideChangeEvent()

  updateSlideHash(currentSlide)
  stopVideos(currentSlide)
  bLazy.revalidate()

  if (secondaryPageView) {
    pageView()
  } else {
    secondaryPageView = true
    window.dataLayer.push({
      pageNumber: String(currentSlide)
    })
  }

  if (upNextContainer) {
    if (currentSlide === slideCount) {
      upNextContainer.classList.remove('--hide')
    } else {
      upNextContainer.classList.add('--hide')
    }
  }

  let beginSlideShow = document.querySelectorAll('.begin-slide-show')
  let previousButtons = document.querySelectorAll(prevSelector)
  if (currentSlide === 1 && abTest) {
    Array.prototype.forEach.call(beginSlideShow, function(item) {
      item.removeAttribute('style')
    })
    Array.prototype.forEach.call(previousButtons, function(item) {
      item.setAttribute('style', 'display:none;')
    })
  } else {
    Array.prototype.forEach.call(beginSlideShow, function(item) {
      item.setAttribute('style', 'display:none;')
    })
    Array.prototype.forEach.call(previousButtons, function(item) {
      item.removeAttribute('style')
    })
  }
}

let closest = function closest(el, fn) {
  while (el) {
    if (fn(el)) {
      return el
    }
    el = el.parentNode
  }
}

let changeToNextSlide = function changeToNextSlide() {
  let nextSlide =
    currentSlide + 1 > slideCount && jumpOffURL === false
      ? slideCount
      : currentSlide + 1

  // Do to next url
  if (nextSlide > slideCount && jumpOffURL) {
    window.location.href = jumpOffURL
  } else {
    changeToSlide(nextSlide)
  }
}

let changeToPrevSlide = function changeToPrevSlide() {
  let prevSlide = currentSlide - 1 < 1 ? 1 : currentSlide - 1

  changeToSlide(prevSlide)
}

// Page refresh actions
let pageView = function pageView() {
  meta.cleanHouse()

  window.dataLayer.push({
    event: 'VirtualPageview',
    pageNumber: String(currentSlide)
  })

  window.dataLayer.push({
    cd12: currentSlide
  })
}

let nextClick = function nextClick(event) {
  let nextButton = closest(event.target, function(elm) {
    return elm &&
      elm.getAttribute &&
      elm.getAttribute(nextSelector.replace(/\[|\]/g, '')) !== null
      ? true
      : null
  })

  if (nextButton) {
    if (nextButton.getAttribute(scrollToTop) === 'true') {
      window.scrollTo(0, 0)
    }

    event.preventDefault()
    changeToNextSlide()
  }
}

let prevClick = function prevClick(event) {
  let prevButton = closest(event.target, function(elm) {
    return elm &&
      elm.getAttribute &&
      elm.getAttribute(prevSelector.replace(/\[|\]/g, '')) !== null
      ? true
      : null
  })

  if (prevButton) {
    if (prevButton.getAttribute(scrollToTop) === 'true') {
      window.scrollTo(0, 0)
    }

    event.preventDefault()
    changeToPrevSlide()
  }
}

let showAllClick = function showAllClick(event) {
  let showAllButton = closest(event.target, function(elm) {
    return elm &&
      elm.getAttribute &&
      elm.getAttribute(showAllSelector.replace(/\[|]/g, '')) !== null
      ? true
      : null
  })

  if (showAllButton) {
    event.preventDefault()
    showAll()
  }
}

let dispatchSlideChangeEvent = function dispatchSlideChangeEvent() {
  let event = new CustomEvent('slideChange', {
    detail: {
      slideCount: slideCount,
      currentSlide: currentSlide
    }
  })
  document.dispatchEvent(event)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}

document.addEventListener('click', nextClick)
document.addEventListener('click', prevClick)
document.addEventListener('click', showAllClick)
